// CNN-style ticker that sits right under any hero block. Pure CSS marquee:
// the track holds two copies of the items list and animates from translateX(0)
// to translateX(-50%), so the seam between copies passes through the viewport
// invisibly and the loop has no jump. Hover pauses it; prefers-reduced-motion
// stops it entirely (see hero-ticker.css). The second copy exists purely for
// the seamless loop, so it's aria-hidden.

interface HeroTickerProps {
  items: string[];
  badge?: string;
}

export function HeroTicker({ items, badge = 'TODAY' }: HeroTickerProps) {
  if (items.length === 0) return null;

  const renderItems = (hidden: boolean) =>
    items.map((text, i) => (
      <span
        className="hero-ticker-item"
        key={hidden ? `dup-${i}` : i}
        aria-hidden={hidden || undefined}
      >
        <i className="hero-ticker-dot" aria-hidden="true" />
        {text}
      </span>
    ));

  return (
    <div className="hero-ticker" aria-label={`${badge} updates`}>
      <div className="hero-ticker-badge" aria-hidden="true">
        {badge}
      </div>
      <div className="hero-ticker-viewport">
        <div className="hero-ticker-track">
          {renderItems(false)}
          {renderItems(true)}
        </div>
      </div>
    </div>
  );
}
